/*
 * @Descripttion: 浅蓝色
 * @Author: shenah
 * @Date: 2023-07-19 09:06:56
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:36:49
 */

export default {
  name: "浅蓝风",
  value: "pureStyle",
  picture: "e098f4e5fd65452e90a578f3e9e3445f",
  style: {
    //页面
    dataviewPage: {
      //字体颜色
      fontColor: "#FFFFFF",
      //页面背景
      backgroundConfig: {
        active: "color",
        color: {
          type: "color",
          image: null,
          isTheme: false,
          theme: "main",
          value: "rgba(234, 249, 255, 1)",
        },
        pattern: {
          image: "",
        },
      },
    },
    // 选中与未选中的样式
    dataViewSelectStyle: {
      defaultColor: "#fff",
      clickColor: "#27B6FF",
    },
    //面板标题
    dataviewPanelText: {
      backgroundConfig: {
        active: "pattern",
        pattern: {
          image: "c43ecfcc20da48cb967540ff1870b5f9",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      subTitleColor: "#ffffff",
    },
    //面板组件
    dataviewPanel: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "c43ecfcc20da48cb967540ff1870b5f9",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      //子标题
      subTitleColor: "#ffffff",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //头部横栏
    dataviewHeaderContent: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "ff6c37985411427e98bcf2ee50160f32",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "#ffffff",
      //子标题
      subTitleColor: "#ffffff",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //表格组件
    dataviewTable: {
      barColors: ["#27B6FF"], // 柱体的背景色
      prop_headerBGC: "", // 统一的表头背景色
      prop_headerColor: "#27B6FF", // 统一的表头颜色
      contentColor: "#27B6FF", // 统一的内容颜色
    },
    //图表组件
    dataviewGraph: {
      // 标题
      title: {
        labelColor: "#27B6FF",
      },
      // 图例
      legend: {
        labelColor: "#27B6FF",
      },
      // 坐标系颜色控制
      axis: {
        labelColor: "rgba(39, 182, 255, 1)",
        lineColor: "rgba(188, 195, 198, 1)",
      },
      // 地图颜色设置
      map: {
        colors: ["rgba(174,225,255,1)"], // 地图区域颜色
        labelColor: "#27B6FF", // 地图文字颜色
        borderColor: "rgba(155,175,196,1)", // 地图边线文字
      },
      // 图形颜色设置
      commonStyle: {
        colors: [
          [
            "rgba(39,182,255,0.2)",
            "rgba(39,182,255,0.6)",
            "rgba(39,182,255,1)",
          ],
          [
            "rgba(255,243,157,0.2)",
            "rgba(255,243,157,0.6)",
            "rgba(255,243,157,1)",
          ],
          [
            "rgba(255,220,76,0.2)",
            "rgba(255,220,76,0.6)",
            "rgba(255,220,76,1)",
          ],
          ["rgba(0,242,189,0.2)", "rgba(0,242,189,0.6)", "rgba(0,242,189,1)"],
          [
            "rgba(255,138,51,0.2)",
            "rgba(255,138,51,0.6)",
            "rgba(255,138,51,1)",
          ],
          [
            "rgba(59,162,114,0.2)",
            "rgba(59,162,114,0.6)",
            "rgba(59,162,114,1)",
          ],
          [
            "rgba(91,110,150,0.2)",
            "rgba(91,110,150,0.6)",
            "rgba(91,110,150,1)",
          ],
        ],
        labelColor: "#27B6FF",
      },
    },
    //图文组件
    dataviewKeyTrades: {
      backgroundConfigs: [], // 单个背景(里面对象则为背景的通用对象)
      attachObj: {
        // 统一
        nameColor: "#27B6FF",
        valueColor: "#27B6FF",
        unitColor: "#27B6FF",
      },
    },
  },
};
